import { DELIVERY_STATUS } from 'services/music-product-digital/types/enums';

export interface ITimestamp {
  start: string;
  end: string;
}

export enum AsapType {
  None = 1,
  AsapToDate = 2,
  Asap = 3,
}

export interface IDigitalDeliveryBase {
  asap: AsapType;
  countryCode: string;
  publishDate: string;
  publishTime: string;
  isTimeZoneBased: null | boolean;
  subscriptionTypeId: null | number;
  endDate: null | string;
  endTime: null | string;
}

export interface IDigitalDeliveryIdentificators {
  productId: string;
  salesChannelId: string;
  providerId: string;
}

export interface IDigitalDeliveryMutation
  extends IDigitalDeliveryIdentificators {
  priority: boolean;
  included: IDigitalDeliveryBase[];
  excluded: IDigitalDeliveryBase[];
  version: number;
  timestamps?: ITimestamp | null;
}

export interface IDigitalDeliveryForm {
  id: string;
  salesChannelName: string;
  providerName: string;
  salesChannelLogo: string | null;
  deliveryType: DELIVERY_METHOD;
  status: DELIVERY_STATUS;
  priority: boolean;
  included: IDigitalDeliveryBase[];
  excluded: IDigitalDeliveryBase[];
  version: number;
  timestamp?: ITimestamp | null;
  expectTimestamp?: boolean | null;
  waitForAssetId?: boolean;
  transferMethod?: TRANSFER_METHOD;
  hasDiscrepancy?: boolean | null;
}

export interface ICreateDigitalDelivery extends IDigitalDeliveryMutation {}

export interface IUpdateDigitalDelivery extends IDigitalDeliveryMutation {}

export interface ICreateAllDigitalDeliveries {
  productId: string;
  priority: boolean;
  included: IDigitalDeliveryBase[];
  excluded: IDigitalDeliveryBase[];
  timestamps?: ITimestamp | null;
}

export interface ICancelDigitalDelivery {
  productId: string;
  salesChannel: string | null;
  providerId: string | null;
}

export interface IWithdrawDigitalDelivery
  extends IDigitalDeliveryIdentificators {
  priority: boolean;
}

export interface IUnsupportedRolesParams {
  digitalMusicProductId: string;
  salesChannelId: string;
}

export type IUnsupportedRolesResponse = number[];

export interface IUpdateDigitalDeliveryStatus extends ICancelDigitalDelivery {
  statusId: DELIVERY_STATUS;
}

export interface IDigitalDeliveryResponse extends IDigitalDeliveryMutation {
  id: string;
  salesChannelName: string;
  salesChannelLogo: string | null;
  providerName: string;
  deliveryMethod: DELIVERY_METHOD;
  deliveryType: DELIVERY_METHOD;
  status: DELIVERY_STATUS;
  version: number;
  timestamp?: ITimestamp | null;
  expectTimestamp?: boolean | null;
  hasDiscrepancy: boolean | null;
}

export enum DELIVERY_METHOD {
  unknown = -1,
  Ddex382 = 0,
  Ddex43 = 1,
  Manual = 2,
}

export enum TRANSFER_METHOD {
  unknown = -1,
  Blob = 0,
  Ftp = 1,
  Sftp = 2,
}
